import { render, staticRenderFns } from "./RsSurveyCompleted.vue?vue&type=template&id=bea2fd6a&scoped=true"
import script from "./RsSurveyCompleted.vue?vue&type=script&lang=js"
export * from "./RsSurveyCompleted.vue?vue&type=script&lang=js"
import style0 from "./RsSurveyCompleted.vue?vue&type=style&index=0&id=bea2fd6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea2fd6a",
  null
  
)

export default component.exports